<template>
  <v-dialog
      v-model="isOpen"
      width="650"
      @click:outside="$emit('close')"
    >
      <v-card class="d-flex flex-column align-items-center p-2">
        <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
        <v-card-title class="pb-0">Alerta</v-card-title>
        <v-divider class="w-100"></v-divider>
        <v-card-text class="d-flex flex-column align-items-center">
          <h6>Existem animais com menos de 2 Kilos, você precisa decidir se:</h6>
          <ol>
            <li>Encerre o animal</li>
            <li>Coloque-o para a próxima inspeção</li>
          </ol>
          <v-divider class="w-100"></v-divider>
          <ol>
            <li v-for="animal in animalsWithErrors" :key="animal.animal_id">
              <span class="mx-3">{{animal.animal.register}}</span>
              -
              <span class="ml-3">{{animal.animal.name}}</span>
            </li>
          </ol>
        </v-card-text>
        <v-card-actions>
          <v-btn class="error" @click="$emit('close')">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name:"AlertTwoWeights",
  props:{
    isOpen:Boolean,
    animals:Array
  },
  computed: {
    animalsWithErrors() {
      return this.animals.filter((set => f => !set.has(f.animal_id) && set.add(f.animal_id))(new Set))
    }
  }
}
</script>

<style scoped>
 .close-icon {
    right: 10px;
    top: 10px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>